/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { GetStudentsParams, StudentsResponse } from "./GetAllStudents";

export const getBlockedStudents = async ({
  page,
  limit,
  firstName,
  status,
  phone,
  email,
}: GetStudentsParams): Promise<StudentsResponse> => {
  try {
    const response = await axios.get(`/student/blocked`, {
      params: { page, limit, firstName, status, phone, email },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
